import Error500 from "@/components/500";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import MobileBottomNav from '@/components/MobileBottomNav';

export default function ServerError() {
    return <>
        <Header />
        <Error500 />
        <Footer hasMobileNav />
        <MobileBottomNav />
    </>;
}
